import * as React from 'react';

import { ErrorMsg } from '../';
import { addModifiers } from '../../../shared/helpers';

import './Input.scss';

interface InputProps {
  type?: 'text' | 'email' | 'search' | 'number' | 'password';
  name: string;
  label?: string | null;
  value?: string;
  handleChange: (event: any, options?: any) => void;
  modifiers?: string[];
  contentModifiers?: string[];
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  handleOptions?: any;
  errors?: any[];
  id?: string;
  tabindex?: number;
  min?: number | null;
  max?: number | null;
  step?: string | null;
}

class Input extends React.Component<InputProps> {
  handleChange = (event: any) => {
    this.props.handleChange(event, this.props.handleOptions);
  };

  componentDidMount() {
    const event = {
      target: {
        type: this.props.type,
        value: this.props.value,
        name: this.props.name,
      },
    };

    this.props.handleChange(event, this.props.handleOptions);
  }
  render() {
    const {
      type = 'text',
      name,
      errors = [],
      label = null,
      value = '',
      modifiers = [],
      contentModifiers = [],
      disabled = false,
      required = false,
      placeholder = '',
      id,
      tabindex = 0,
      min = null,
      max = null,
      step = null,
    } = this.props;

    let othersProps = {};

    if (min !== null) {
      othersProps = { ...othersProps, ...{ min } };
    }
    if (max !== null) {
      othersProps = { ...othersProps, ...{ max } };
    }

    if (step !== null) {
      othersProps = { ...othersProps, ...{ step } };
    }

    return (
      <div className={addModifiers('input__content', contentModifiers)}>
        {label && (
          <label htmlFor={id} className="input__label">
            {label}
            {required && <sup className="input__sup">*</sup>}
          </label>
        )}
        <input
          type={type}
          name={name}
          value={value}
          disabled={disabled}
          onChange={this.handleChange}
          className={addModifiers('input__elem', modifiers)}
          placeholder={placeholder}
          id={id}
          tabIndex={tabindex}
          {...othersProps}
        />
        <div className="input__error">{errors.length !== 0 && <ErrorMsg errors={errors} />}</div>
      </div>
    );
  }
}

export default Input;
